import { inject, Injectable } from '@angular/core';
import { AuthService } from '../../../app/services/auth.service';
import { AWSLambda } from '../../AWSLambda.service';
import { Auth } from 'aws-amplify';
import { DatePipe } from '@angular/common';
import { GlobalDataService } from '../../services/global-data.service';

@Injectable({
  providedIn: 'root'
})

export class MobileService {

  lambda = inject(AWSLambda);
  authService = inject(AuthService);
  private datePipe = inject(DatePipe);

  constructor(private globalDataService: GlobalDataService) { }

  async init() {
    await this.authService.refresh();
  }

  async getusuario() {
    try {

      const user = await Auth.currentAuthenticatedUser();
      const attributes = await Auth.userAttributes(user);
      //return "75071892F" //--se migro
      //return "50853389K" 
      //return "Y0023497M" //---tarifa internacional ver limites
      return attributes.find(attribute => attribute.Name === 'custom:passport')?.Value;
    } catch {

      console.log('error no logueado')
      return ''
    }
  }

  async getContracts() {
    var response = []
    const raw = sessionStorage.getItem(btoa('mobile_contracts'));
    if (raw) {
      response = JSON.parse(atob(raw));
      if (response.length > 0) return response;
    }

    const owner = await this.getusuario();

    const contracts_tmp = await this.lambda.getLambdaFunction(
      'lambda',
      '/aire/api',
      {
        queryStringParameters: {
          opcion: "getLineas",
          parametros: JSON.stringify({
            fiscalId: owner,
            activo: "SI"
          })
        }
      }
    ) || [];

    const contracts = (contracts_tmp?.data?.return && Object.keys(contracts_tmp.data.return).length > 0)
      ? contracts_tmp.data.return
      : [];

    
    const contracts_isp = await this.lambda.getLambdaFunction(
        'lambda',
        '/isp/api',
        {
            queryStringParameters: {
                method: "",
                owner: owner
            }
        }
    ) || [];


    for (let contract of contracts) {
      const ddi = contract.telefono;
      const consumption: any = await this.getContractConsumption(ddi) || [];

      const title = contract.tarifa[0].nombre.replace(/�/g, ' ').replace(/[^\x20-\x7E\u00A0-\u00FF\u0100-\u017F\u0180-\u024F]/g, ' ');
      
      /*
      const utf8Bytes = new TextEncoder().encode(contract.tarifa[0].nombre);
      const title = String.fromCharCode(...utf8Bytes);
      */
      
      const sim = contract.sims[0];
     
      let voicenational = consumption.voz.bono
        .filter((item: { contratado: string; consumido: string }) => parseInt(item.contratado) >= 3000)
        .reduce(
          (acc: { total: number; used: number }, item: { contratado: string; consumido: string }) => {
            acc.total += parseInt(item.contratado);
            acc.used += parseInt(item.consumido);
            return acc;
          },
          { total: 0, used: 0 }
        );

      let voiceinternational = consumption.voz.bono
        .filter((item: { contratado: string; consumido: string }) => parseInt(item.contratado) < 3000)
        .reduce(
          (acc: { total: number; used: number }, item: { contratado: string; consumido: string }) => {
            acc.total += parseInt(item.contratado);
            acc.used += parseInt(item.consumido);
            return acc;
          },
          { total: 0, used: 0 }
      );

      const contrato = contracts_isp.contracts.find((c: { servicios: { telefono_contrato_asociado: any; }[]; }) =>
        c.servicios.some((s: { telefono_contrato_asociado: any; }) => s.telefono_contrato_asociado === ddi)
      );
      let price = contrato.importe_remesar;
      
      response.push({
        "consumption": {
          "data": {
            "total": consumption.datos.contratado - 1,
            "used": consumption.datos.consumido
          },
          "sms": {
            "total": consumption.sms.contratado,
            "used": consumption.sms.consumido
          },
          "minutes": {
            "national": {
              "total": voicenational.total,
              "used": voicenational.used
            },
            "international": {
              "total": voiceinternational.total,
              "used": voiceinternational.used
            }
          }
        },
        "title": title,
        "number": ddi,
        "pin1": sim.pin1,
        "pin2": sim.pin2,
        "puk1": sim.puk,
        "puk2": sim.puk2,
        "amount": price,
        "allow_free_transfer": contracts_isp.allow_free_transfer
      })
    }
    sessionStorage.setItem(btoa('mobile_contracts'), btoa(JSON.stringify(response)));

    this.globalDataService.allowFreeTransfer = contracts_isp.allow_free_transfer;

    return response
  }

  async getBills(iccid: string, from: string, to: string) {
    let today = new Date();
    today.setDate(1); // First day of the current month

    let lastDay = new Date(today);
    lastDay.setMonth(lastDay.getMonth() + 1);
    lastDay.setDate(0); // Last day of the current month

    let todayStr = from == "" ? null : from;
    let lastDayStr = to == "" ? null : to;
    const owner = await this.getusuario();
    const bills = await this.lambda.getLambdaFunction(
      'lambda',
      '/isp/api',
      {
          queryStringParameters: {
              method: "facturas",
              owner: owner,
              fecha_inicio: from,
              fecha_fin: to
          }
      }
    ) || [];

    var response = []
    
    for (let bill of bills) {
      let date = new Date(bill.fecha)
      response.push({
        "type": "MOBILE",
        "factura": bill.factura,
        "fecha": date.getTime() ,
        "id": bill.id,
        "situacion": bill.situacion,
        "total": bill.total
      } )
    }
    return response;
  }

  async getBill(factura: string) {
    const bill = await this.lambda.getLambdaFunction(
      'lambda',
      '/isp/api',
      {
        queryStringParameters: {
          method: "facturas/downloads",
          factura: factura
        }
      }
    );
    return bill;
  }

  async getContractConsumption(iccid: string) {
    const data = await this.lambda.getLambdaFunction(
      'lambda',
      '/aire/api',
      {
        queryStringParameters: {
          opcion: "consumosLinea",//"getServicios",
          parametros: JSON.stringify({
            telefono: iccid
          })
        }
      }
    ) || [];
    
    /*
    const data = await this.lambda.getLambdaFunction(
      'lambda',
      '/isp/api',
      {
        queryStringParameters: {
          method: "consulta_consumo",
          ddi: iccid,
          fecha_inicio: from,
          fecha_fin: to
        }
      }
    );
    */
    return data.data;
  }

    async getContractMonthResume(iccid: string, mes: number, anio: number, tipo: number) {
    const resume = await this.lambda.getLambdaFunction(
      'lambda',
      '/isp/api',
      {
        queryStringParameters: {
          method: "resumen_cdr",
          ddi: iccid,
          mes: mes,
          anio: anio,
          tipo: tipo
        }
      }
    );
    return resume;
  }
}
